import type { AppLauncherSection } from "@codelittinc/carbon-design-system";
import type { Tool } from "@carbon-os/server/contract";
import { isHttpUrl, toolLogoUrl } from "./tools";

/**
 * The header's app switcher, built from the tool list the page already has:
 * the same Gatekeeper `apps` My tools renders, so it makes no call of its own.
 * Gatekeeper and the Delinquency Center lay theirs out the same way.
 */

/** This app's access key in Gatekeeper (GATEKEEPER_APP_KEY in production). */
export const CARBON_OS_KEY = "carbon-os";

export const CARBONOS_HEADING = "CarbonOS apps";
export const EXTERNAL_HEADING = "Other tools";

/**
 * CarbonOS apps then Other tools, as in Gatekeeper; the design system merges
 * them into one list sorted by name. Carbon OS is always listed and marked
 * current, from its own tool when the person holds it, since whoever reads
 * this is in it. Logos come through carbon-os's `/api/tools/:key/logo`, the
 * same as the cards; a tool with none shows its initials.
 */
export function launcherSections(tools: readonly Tool[]): AppLauncherSection[] {
  const carbonos: AppLauncherSection["apps"] = [];
  const external: AppLauncherSection["apps"] = [];
  let current = false;

  for (const tool of tools) {
    const app = {
      key: tool.key,
      name: tool.name,
      href: isHttpUrl(tool.url) ? tool.url : null,
      iconSrc: toolLogoUrl(tool.key),
    };
    if (tool.key === CARBON_OS_KEY) {
      carbonos.push({ ...app, current: true });
      current = true;
    } else if (tool.kind === "carbonos") {
      carbonos.push(app);
    } else {
      external.push(app);
    }
  }
  if (!current) carbonos.push({ name: "Carbon OS", href: null, current: true });

  return [
    { heading: CARBONOS_HEADING, apps: carbonos },
    { heading: EXTERNAL_HEADING, apps: external },
  ];
}
